import authStorage from "./authStorage";

/**
 * Builds the Authorization header for authenticated requests from the access
 * token in the stored session. Returns an empty object when there is no token.
 */
export default function authHeader() {
  const token = authStorage.getAccessToken();
  return token ? { Authorization: "Bearer " + token } : {};
}
